import { v4 as uuidv4 } from 'uuid';
export class EngagementBaseModel {
    constructor() {
        this.id = uuidv4();
        this.name = '';
        this.type = 'blank';
        this.prospectName = '';
        this.projectTypeId = null;
        this.projectType = null;
        this.createdOn = null;
        this.createdOnAsString = '';
        this.createdOnAsInputString = '';
    }
}
